import TwitterIcon from '@material-ui/icons/Twitter';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import {WebOutlined,YouTube} from "@material-ui/icons";
import SpaOutlinedIcon from '@material-ui/icons/SpaOutlined';
import DeveloperBoardOutlinedIcon from '@material-ui/icons/DeveloperBoardOutlined';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import LinkIcon from '@material-ui/icons/Link';

export default  {
    name: 'Arup Paul',
    title: 'Web Developer',

    birth_date: '12 JUne 1998',
    email:'aruppaulctg@gmail.com',
    address:'Chattogram',
    cv:'https://drive.google.com/file/d/1BBzpCukFULrwebPET2JitB_ABYRG5Ni-/view?usp=sharing',

    socials: {
        linkedin: {
            link:'https://www.linkedin.com/in/arup-paul-278097177/',
            text: 'Arup Paul',
            icon: <LinkedInIcon />
        },
        github: {
            link:'https://github.com/Arup-paul',
            text: 'Arup Paul',
            icon: <GitHubIcon />
        },
        twitter: {
            link:'https://twitter.com/Arup_paul_bd',
            text: 'Arup Paul',
            icon: <TwitterIcon />
        }


    },

    about: "Hello! My name is Arup Paul and i'm a Web Developer more than 1.5+ year  professional experience,  Currently working as a fulltime Web Developer at AMCoders. Learning about new technology is one of my passion. Learning NEXT JS , Inertia JS,Tailwind Css and more. \n\n  In my free time i like to do playing cricket and capture some natural photography.",
    experiences:[
        {
            title:'AMCoders',
            date:'March 2022 to Present ',
            description:'Developing and Maintaining Laravel Based web application for Codecanyon'
        },
        {
            title:'SHONGJOGyou',
            date:'02 November 2020  to February 2022 ',
            description:'Developing and implementing highly responsive user interface components using react \n\n and develop api Based web application in Laravel '
        },
    ],
    education:[
        {
            title:'BSC in CSE',
            date:'2019 to Present',
            description:'East Delta University'
        },
        {
            title:'Diploma in Computer Technology',
            date:'2014 to 2018',
            description:'Chattogram Polytechnic Institute'
        },
    ],
    
    services: [
        {
            title: 'FRONTEND DEVELOPMENT',
            description:'Front-end web development is the development of the graphical user interface of a website, through the use of HTML, CSS, and JavaScript, so that users can view and interact with that website',
            icon: <AssessmentOutlinedIcon />
        } ,
        {
            title: 'BACKEND DEVELOPMENT',
            description:'Backend Development is also known as server-side development. It is everything that the users don\'t see and contains behind-the-scenes activities that occur when performing any action on a website. It focuses primarily on databases, backend logic, APIs, and Servers',
            icon: <DeveloperBoardOutlinedIcon />
        },
        {
            title: 'Single Page Application DEVELOPMENT',
            description:'A single-page application (SPA) is a web Application or website that interacts with the user by dynamically rewriting the current web page with new data from the web server, instead of the default method of the browser loading entire new pages. The goal is faster transitions that make the website feel more like a native app.',
            icon: <SpaOutlinedIcon />
        }
    ],

    skills:[
        {
           title:'FRONTEND',
           description: ['React', 'Javascript','Jquery','Bootstrap','Html','Css']
        },
        {
            title: 'BACKEND',
            description: ['Laravel','PHP','REST API']
        },
        {
            title: 'DATABASE',
            description: ['MYSQL','Firebase']
        },
        {
            title: 'VERSION CONTROL',
            description: ['Git','Github']
        },
        {
            title: 'Operating System',
            description: ['Windows','Linux Mint']
        },
    ],

    projects:[
        {
            tag:'Laravel',
            image:"/portfolio/sass2.png",
            images:[
                "/portfolio/sass1.png",
                "/portfolio/sass3.png",
                "/portfolio/sass4.png",
            ],
            title:'OPEN SASS',
            caption:'Sell Your Skills As A Subscription (SAAS)',
            description:'OpenSAAS is a multi-level subscription selling platform. Here freelancer can sell subscription based on there skill. Buyers can purchase freelancer subscription and also cancel the subscription anytime. Freelancer can be a buyer and buyer can be a freelancer. Freelancers need to purchase subscriptions to create their subscriptions. This script has a real time chat system for communicate with freelancer and buyer based on project task. The site admin will earn from selling subscription and withdraw / payout charge and currency rate.',
            links:[
                {link:'https://codecanyon.net/item/opensaas-multi-level-subscription-selling-platform/38629226?s_rank=1',icon:<LinkIcon />},
            ]
        },
        {
            tag:'Laravel',
            image:"/portfolio/1.png",
            images:[
                "/portfolio/1.png",
                "/portfolio/2.png",
            ],
            title:'SHONGJOGyou',
            caption:'E-Finance Soluttion',
            description:'To build a prosperous nation, SHONGJOGyou is trying to generate a driving force to speed up the financial and economy of the country. Reducing the lack of financial services to the middle- and lower-class people is one of the main goals of SHONGJOGyou. From the economical year of 2018, our team is working hard to solve the main financial complexity, lacking, and poverty. Our team is working across Bangladesh to make a bridge between different kinds of financial organizations like Banking, Micro Credit, Financial Companies, Co-operative, and venture capital, etc.',
            links:[
                {link:'https://shongjogyou.com/',icon:<LinkIcon />},
            ]
        },

        {
            tag:'Laravel',
            image:"/portfolio/3.png",
            images:[
                "/portfolio/3.png",
                "/portfolio/4.png",
                "/portfolio/5.png",
            ],
            title:'Bona',
            caption:'Blog System Using Laravel',
            description:'Bona Blog System is simple blog system stack use html css mysql php laravel .',
            links:[
                {link:'https://github.com/Arup-paul/bona_laravel_blog_system',icon:<LinkIcon />},
            ]
        },
        {
            tag:'Laravel',
            image:"/portfolio/6.png",
            images:[
                "/portfolio/6.png",
                "/portfolio/7.png",
            ],
            title:'Inventory Management System',
            caption:'Inventory Management System Using Laravel',
            links:[
                {link:'https://github.com/Arup-paul/Inventory-Pos',icon:<LinkIcon />},
            ]
        },
        {
            tag:'Laravel',
            image:"/portfolio/8.png",
            images:[
                "/portfolio/8.png",
                "/portfolio/9.png",
            ],
            title:'Student Management System',
            caption:'Student Management System Using Laravel',
            links:[
                {link:'https://github.com/Arup-paul/Studet-Management-System',icon:<LinkIcon />},
            ]
        },
        {
            tag:'React',
            image:"/portfolio/10.png",
            images:[
                "/portfolio/10.png",
                "/portfolio/11.png",
            ],
            title:'Linkedin Clone',
            caption:'Linkedin Clone Using React',
            links:[
                {link:'https://github.com/Arup-paul/linkedin-clone-react',icon:<LinkIcon />},
            ]
        },
        {
            tag:'React',
            image:"/portfolio/12.png",
            images:[
                "/portfolio/12.png",
                "/portfolio/13.png",
            ],
            title:'Youtube Clone',
            caption:'Youtube Clone Using React',
            links:[
                {link:'https://yt-clone-arup1.web.app/',icon:<LinkIcon />},
                {link:'https://github.com/Arup-paul/youtube-clone',icon:<LinkIcon />},
            ]
        },

    ]




}